// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__1yFHI"};